import { VariantProps, cva } from 'class-variance-authority';

import { AwardsConfigProps } from 'molecules/Awards/config';
import Image from 'molecules/Image';

import type { FC } from 'react';

interface AwardsProps extends AwardsConfigProps, VariantProps<typeof awardsContainerStyles> {}

const awardsContainerStyles = cva('flex flex-wrap items-center justify-center max-sm:justify-center md:flex-nowrap', {
  variants: {
    size: {
      sm: 'gap-3 sm:gap-5 lg:gap-6',
      md: 'gap-3 sm:gap-7 lg:gap-8',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

const awardStyles = cva('h-auto shrink-0', {
  variants: {
    size: {
      sm: 'w-20 max-sm:w-[24%] sm:w-24 lg:w-28',
      md: 'w-24 max-sm:w-[22%] sm:w-28 lg:w-32',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

const Awards: FC<AwardsProps> = ({ awardItems, size }) => (
  <div className={awardsContainerStyles({ size })}>
    {awardItems?.map(({ id, awardImage }) => (
      <Image
        key={id}
        url={awardImage?.file?.url ?? '/placeholder.png'}
        className={awardStyles({ size })}
        alt={awardImage?.alt ?? ''}
        width={awardImage?.file?.width ?? 176}
        height={awardImage?.file?.height ?? 176}
        noFill
        unoptimized
        loading="lazy"
        style={
          {
            objectFit: 'contain',
            objectPosition: 'center',
          } as React.CSSProperties
        }
      />
    ))}
  </div>
);

export default Awards;
